import { useState, useLayoutEffect } from 'react';
import { useCommStore } from '@/components/communication/commStore';

// The page's size. When the messages column is open on the left, `width` is
// what is left next to it, so pages lay themselves out in the space they
// really have; `{ full: true }` gives the whole window (the top menu, the
// messages inbox).
const useWindowSize = ({ full = false } = {}) => {
	const [size, setSize] = useState({
		width: undefined,
		height: undefined,
	});
	const columnWidth = useCommStore(s => s.columnWidth);

	useLayoutEffect(() => {
		const handleResize = () => {
			setSize({
				width: window.innerWidth,
				height: window.innerHeight,
			});
		};

		handleResize();

		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	if (full || !columnWidth || size.width === undefined) return size;
	return { ...size, width: Math.max(size.width - columnWidth, 0) };
};

export default useWindowSize;
